<kendo-expansionpanel [class]="expensionPanelClass()" [expanded]="accordionExpanded">
  <ng-template kendoExpansionPanelTitleDirective>
    <div class="expansionpanel-title">
      {{ openClosedCaption() | transloco }}
      @if (!isOpen() && !alwaysClosed()) {
        <span
          class="desktop-xs-descriptive text-[--text-description] working-hours-content-text"
          [innerHTML]="whenOpensCaption() | transloco: { hours: tillStart().hours, minutes: tillStart().minutes }"
        ></span>
      }
    </div>
  </ng-template>
  <div class="flex flex-col gap-[10px] working-hours-content">
    @if (isDifferentTimezone()) {
      <div class="border mx-4"></div>
      <div class="flex flex-row gap-2 mr-4">
        <cue-icon [icon]="ICONS.cueExclamation" />

        <div class="desktop-xs-descriptive">
          {{ translation.workingHours.differentTimezone | transloco }}
          <div class="p-1"></div>
          {{ translation.workingHours.locationTimezone | transloco }}
          <span class="desktop-xs-bold-descrioptive-strong working-hours-content-text">
            {{ ianaTimeZone() }} ({{ resourceTimeZoneOffset() }})
          </span>
        </div>
      </div>
      <div class="border mx-4"></div>
    }
    <div class="grid grid-cols-[auto_1fr] mx-2 gap-x-5 gap-y-2 desktop-xs-descriptive working-hours-content-text">
      @for (day of daysForLocale(); track day) {
        <div class="working-hours-content-text" [class.desktop-xs-bold-descrioptive-strong]="day.today">
          {{ getDayTranslation(day.display) | transloco }}
        </div>
        <div class="working-hours-content-text" [class.desktop-xs-bold-descrioptive-strong]="day.today">
          @if (day.active) {
            @for (slot of day.slots; track $index) {
              <span>
                {{ slot.start | timeFormat }} -
                {{ slot.end | timeFormat }}
                @if (!$last) {
                  ,
                }
              </span>
            }
          }

          @if (!day.active) {
            {{ translation.workingHours.closed | transloco }}
          }
        </div>
      }
    </div>
  </div>
</kendo-expansionpanel>
